import Layout from '@layout/Index'

export const tekeTag = [
  {
    path: '/teke_tag',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import('./pages/TekeTagTable.vue'),
        name: '标签管理',
        meta: {
          title: '标签管理',
        },
      },
      {
        path: 'form',
        component: () => import('./pages/TekeTagForm.vue'),
        name: '新建标签',
        meta: {
          title: '新建标签',
        },
      },
      {
        path: 'update/:tagid',
        component: () => import('./pages/TekeTagUpdate.vue'),
        name: '修改标签',
        meta: {
          title: '修改标签',
        },
      },
      {
        path: 'infinite_table',
        component: () => import('./pages/TekeInfiniteTagTable.vue'),
        name: '标签列表',
        meta: {
          title: '标签列表',
        },
      },
      {
        path: 'infinite_form/:tagid',
        component: () => import('./pages/TekeInfiniteTagForm.vue'),
        name: '新建标签类别',
        meta: {
          title: '新建标签类别',
        },
      },
      {
        path: 'infinite_update/:tagid',
        component: () => import('./pages/TekeInfiniteTagUpdate.vue'),
        name: '修改标签类别',
        meta: {
          title: '修改标签类别',
        },
      },
      {
        path: 'infinite_upload_table',
        component: () => import('./pages/TekeInfiniteTagUploadTable.vue'),
        name: '上传列表',
        meta: {
          title: '上传列表',
        },
      },

    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/teke-tag/tekeTag.route.js